require('../../modules/es6.reflect.construct');
module.exports = require('../../modules/_core').Reflect.construct;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/reflect/construct.js
// module id = 1472
// module chunks = 0